module.exports = __webpack_public_path__ + "static/customer_photo_4-9bbf1c5525ccaf4457fa8bd241c99ca6.jpg";